import { render, staticRenderFns } from "./CompleteStockCardMobile.vue?vue&type=template&id=2e35acee&scoped=true&"
import script from "./CompleteStockCardMobile.vue?vue&type=script&lang=js&"
export * from "./CompleteStockCardMobile.vue?vue&type=script&lang=js&"
import style0 from "./CompleteStockCardMobile.vue?vue&type=style&index=0&id=2e35acee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e35acee",
  null
  
)

export default component.exports